
export const en_EN = {
  message: {
    OnlyForBuisness: 'only for Business',
    contact: 'Contact',
    signIn: 'Sign in',
    signUp: 'Sign up',
    blog: 'Blog',
    home: 'home',
    price: 'Price',
    password: 'password',
    repeatPassword: 'repeat password',
    email: 'email',
    username: 'username',
    show: 'show',
    acceptTerms: 'accept terms',
    alreadyAccount: 'Already have an account?',
    forgotEmail: 'forgot email?',
    forgotPassword: 'forgot password?',
    send: 'send',
    dashboard: 'Dashboard',
    goTo: 'go to {name}',
    app: 'App',
    add: 'add {name}',
    youAreNotLoggedIn: 'You are not logged in',
    logout: 'logout',
    confirm: 'confirm {name} now',
    edit: 'edit {name}',
    profile: 'profile',
    embed: 'embed',
    board: 'board | boards',
    feedback: 'feedback | feedbacks',
    website: 'website',
    preview: 'preview',
    createNew: 'create new {name}',
    question: 'question | questions',
    delete: 'delete',
    yes: 'yes',
    no: 'no',
    duplicate: 'duplicate',
    allDataWillBeDeleted: 'all data will be deleted',
    search: 'search',
    date: 'date',
    noEntry: 'no entry | no entries',
    back: 'back',
    validation: 'validation',
    ofStars: '{current} of {all} stars',
    star: 'star | stars',
    terms: 'terms',
    privacy: 'privacy',
    imprint: 'imprint'
  },
  demo: {
    questions: 'How do you rate our product quality? | How do you rate our service?'
  }
}
